import 'events-polyfill';
import '../utils/prepend-polyfill';
import '../utils/append-polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import removePolyfill from '../utils/remove-polyfill';
import MicroModal from 'micromodal';
import 'simplebar';
import SlimSelectComponent from './slim-select';
import tippy from 'tippy.js';

function initGlobalComponents() {
  // Element.remove() on IE
  removePolyfill();

  //smoothscroll
  smoothscroll.polyfill();

  //SlimSelect Component
  _$$('.slim-select').forEach(dropdown => {
    new SlimSelectComponent(dropdown);
  });

  //MicroModal
  const $openTrigger = _$$('a[data-generic-modal-open]');
  const $closeTrigger = _$$('a[data-generic-modal-close]');
  $openTrigger?._on('click', e => e.preventDefault());
  $closeTrigger?._on('click', e => e.preventDefault());
  MicroModal.init({
    openTrigger: 'data-generic-modal-open',
    closeTrigger: 'data-generic-modal-close',
    openClass: 'generic-modal--open',
    disableScroll: true,
    disableFocus: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
  });

  //Tippy
  const tippyTriggerClass = '.rte-tooltip__trigger';
  const $tippyTrigger = _$$('.rte-tooltip__trigger');
  $tippyTrigger?._on('click', e => e.preventDefault());
  tippy(tippyTriggerClass, {
    content(reference) {
      const id = reference.getAttribute('data-template');
      const template = document.getElementById(id);
      return template?.innerHTML || null;
    },
    allowHTML: true,
    theme: 'light',
    arrow: true,
    trigger: 'click',
    placement: 'bottom',
    maxWidth: 330,
    interactive: true,
    appendTo: 'parent'
  });
}

export default initGlobalComponents;
